import React from "react";

export const AccordionContext = React.createContext<{
  isOpen: boolean;
  toggleAccordion: () => void;
}>({
  isOpen: false,
  toggleAccordion: () => {},
});
